const _0 = "0"
const _50 = ".5"
const _100 = "1"
const _150 = "1.5"
const _200 = "2"
const config = { "0": _0, "50": _50, "100": _100, "150": _150, "200": _200,  }
export { config as default, _0, _50, _100, _150, _200 }